import React  from 'react'
/*import profile_img from '../img/profile.jpg'*/
/*import Slider from "react-slick";*/
import {Link} from 'react-scroll'

function resumeabout() {    
   
        return (           
            <div id="about" className=" white-color featured relative topheader-title ">
                <div className="container-fluid">                
                    <div className="min-vh-100 slide-content">
                        <div className="col-12 d-flex min-vh-100">
                            <div className="topheader">
                                <div className="row col-lg-12 ">                                    
                                    {
                                        
                                            <div className="text-center col-sm-12 col-xs-12">
                                               {/*<img src={profile_img} alt="Estebans' Profile" className="rounded-circle " style={{marginBottom: "55px"}}/>*/} 
                                                <h2 className="featured">
                                                    About Me
                                                </h2>                                                                         
                                            </div>
                                        
                                    }                                    
                                    <div className="card-group">
                                   {/*<Slider {...settings} >*/}
                                    <div className="card">
                                            <h3><i className="fa fa-user-tie"></i> Professional Skills</h3>
                                            <div className="post-holder">
                                                <ul>
                                                    <li>Database development: SQL, MySQL.</li>
                                                    <li>Programming Languages: .NET, ASPX, PHP, JavaScript, AJAX,Json, jQuery, ActionScript, XML, REACT JS.</li>	
                                                    <li>Server Platforms/Web Hosting: Apache Server, IIS, Cpanel, DNS, Domain management, SSL certificate, FTP, CMD, SEO tools Google Analytics.</li>	
                                                    <li>Front End: HTML, CSS, responsive web development, accessibility standards.</li>	
                                                    <li>Network: TCP/IP, routers ,switches ,local networks, printers.</li>	
                                                    <li>Software: Photoshop, Illustrator, Indesign, Fireworks, Dreamweaver, Flash ,3ds Max, After Effects, Visual Studio ,Vs Code ,Notepad++, Microsoft Office.</li>	                                                                                       
                                                </ul>
                                            </div>
                                        </div>
                                    <div className="card">
                                        <h3><i className="fa fa-user-shield"></i> Personal Strengths</h3>
                                        <div className="post-holder">
                                            <ul>
                                                <li>Highly self-motivated with strong eagerness to learn new things.</li>
                                                <li>Flexible and versatile with demonstrated ability to easily work well in a group or independent.</li>	
                                                <li>Regarded as friendly, responsible, and helpful by former employers and co-workers.</li>	
                                                <li>Able to manage teams and collaborate towards the company goals.</li>	
                                                <li>Attention to details, excellent interpersonal skills, customer service oriented.</li>	
                                                <li>Problem solving oriented.</li>	
                                                <li>Fluent speaking, reading and writing English and Spanish.</li>	                                        
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <h3><i className="fa fa-heart"></i> Interests and More</h3>
                                        <div className="post-holder">
                                            <div>I'm a Canadian/Costa Rican who moved to Thunder Bay in 2012.</div><br></br>
                                            <div>When I'm out of office hours, I truly enjoy:</div>
                                            <ul>
                                                <li>Having quality and fun time with my children.</li>
                                                <li>Take our dog for a walk.</li>
                                                <li>Play and watch soccer.</li>                                                
                                                <li>The summer outdoors, fishing and camping with the family.</li>
                                                <li>Play guitar in a very amateur level.</li>
                                                <li>Cooking for my family.</li>                                                
                                            </ul>
                                            <p>*No specific order</p>
                                        </div>
                                    </div>
                                          <br></br>                                  
                                    {/*</Slider>*/}  
                                    </div>
                                </div>                                                                                                                                      
                            </div>
                        </div>
                    </div>                
                </div>
                <Link to="latest" spy={true} smooth={true}>
                    <h2 className="arrow-bottom"><i className="fa fa-arrow-circle-down"></i></h2>
                </Link>
                
            </div>            
        )    
}

export default resumeabout;
